"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const _FloatingContent_1 = require("../_FloatingContent");
// styles
require("./tooltip.scss");
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-tooltip",
    arrow: false,
    position: "top-center",
    secondary: false,
    outlined: false,
};
const Tooltip = (_a) => {
    var { trigger, children, arrow, position, secondary, outlined, triggerEvent, className } = _a, rest = __rest(_a, ["trigger", "children", "arrow", "position", "secondary", "outlined", "triggerEvent", "className"]);
    const [isShown, setIsShown] = (0, react_1.useState)(false);
    const classList = (0, classnames_1.default)("tecma-tooltip", { arrow }, { secondary }, { outlined }, { [`${position}`]: position }, { [`${triggerEvent}`]: triggerEvent }, className);
    const toggle = () => setIsShown(!isShown);
    return ((0, jsx_runtime_1.jsx)(_FloatingContent_1.FloatingContent, Object.assign({ trigger: trigger, isShown: isShown, position: position, onToggle: toggle, action: triggerEvent }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classList }, rest, { children: children })) })));
};
Tooltip.defaultProps = defaultProps;
exports.default = react_1.default.memo(Tooltip);
